<template>
  <div>
    <div class="main" v-if="isPC">
      <p class="page-title">{{ $t('myInformation.myInformation') }}</p>
      <section class="bg-white">
        <h2>{{ $t('PersonalCenter.MyInformation.Index.CompanyInformation') }}</h2>
        <div v-if="!form.approvalStatus||form.approvalStatus===0" class="certificate-tips f" style="width:864px" >
          <div class="certificate-statu fd-c f--c">
            <img src="@/assets/img/uncertificate.svg" alt="">
            <span>{{ $t('PersonalCenter.MyInformation.Index.UNVERIFIEDBUYER') }}</span>
          </div>
          <div class="certificate-info">
            <p>{{ $t('PersonalCenter.MyInformation.Index.Tips1') }} <span class="pointer" @click="$refs.certificateEquipmentDialog.show()">{{ $t('PersonalCenter.MyInformation.Index.Here') }}</span>.</p>
          </div>
        </div>
        <div v-if="form.approvalStatus===1" class="certificate-tips f" style="width:864px" >
          <div class="certificate-statu fd-c f--c">
            <img src="@/assets/img/certificating.svg" alt="">
            <span>{{ $t('PersonalCenter.MyInformation.Index.UnderReview') }}</span>
          </div>
          <div class="certificate-info">
            <p>  *{{ $t('PersonalCenter.MyInformation.Index.Tips2') }}</p>
          </div>
        </div>
        <div v-if="form.approvalStatus===2" class="certificate-tips f" style="width:864px" >
          <div class="certificate-statu fd-c f--c">
            <img src="@/assets/img/certificate-fail.svg" alt="">
            <span>{{ $t('PersonalCenter.MyInformation.Index.AuditFailure') }}</span>
          </div>
          <div class="certificate-info">
            <p style="color:#E53238">{{form.reasonForRejection}}</p>
          </div>
        </div>
        <div v-if="form.approvalStatus===3" class="certificate-tips f" style="width:183px;border: 0.5px solid #10141D" >
          <div class="certificate-statu fd-c f--c">
            <img src="@/assets/img/certificated.svg" alt="">
            <span>{{ $t('PersonalCenter.MyInformation.Index.AuthenticatedBuyer') }}</span>
          </div>
        </div>
        <el-form label-position="top" :model="form" :rules="rules" ref="form" label-width="100px">
          <el-row>
            <el-col :span="12" style="padding-right: 30px;">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.FirstName')" prop="first">
                <el-input v-model="form.first"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.LastName')" prop="last">
                <el-input v-model="form.last"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.CompanyName')" prop="companyName">
                <el-input v-model="form.companyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px" >
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.DoYouSellOnline')" prop="ifSellOnline" >
                <el-radio-group v-model="form.ifSellOnline" >
                  <el-radio :label="1">{{ $t('PersonalCenter.MyInformation.Index.Yes') }}</el-radio>
                  <el-radio :label="0">{{ $t('PersonalCenter.MyInformation.Index.No') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px"  v-show="form.ifSellOnline===1"  >
                <el-form-item :label="$t('PersonalCenter.MyInformation.Index.StoreURL')"  :rules="form.ifSellOnline===1?[{required:true,message:'Please enter your store url',trigger:['change','blur']}]:[]">
                  <el-input v-model="form.storeUrl"  :class="{requiredInputPC:form.ifSellOnline===1}"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.SellerPermitNumber')" prop="sellerPermit" :rules="form.ifSellOnline===0?[{ required: true, message: 'Please enter your seller permit number', trigger: ['change', 'blur'] }]:[]">
                <el-input v-model="form.sellerPermit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.StorePicture')">
                <div class="storePicture demo-image__preview f-c-c" v-if="form.storePicture && form.storePicture!==''">
                  <div class="icon pointer" @click="removeStorePicture">×</div>
                  <el-image fit="contain" style="width: 104px; height: 110px" :src="form.storePicture" :preview-src-list="[form.storePicture]">
                  </el-image>
                </div>
                <el-upload v-else list-type="picture-card" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :multiple="false" accept="image/*" :before-upload="beforeUpload">
                  <i class="el-icon-circle-plus-outline"></i>
                  <span class="el-upload__text">{{ $t('PersonalCenter.MyInformation.Index.Image') }}</span>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <h2>{{ $t('PersonalCenter.MyInformation.Index.DocumentOfProof') }}</h2>
              <p class="upload-tip">{{ $t('PersonalCenter.MyInformation.Index.DocumentProofOfBusiness') }}</p>
              <p class="upload-tip">{{ $t('PersonalCenter.MyInformation.Index.Tips3') }} <span class="pointer" @click="$refs.certificateEquipmentDialog.show()">{{ $t('PersonalCenter.MyInformation.Index.Here') }}</span>.</p>
              <div class="f" style="margin:10px 0">
                <div v-for="(item,index) in documentFiles" :key="index" class="upload-demo-box">
                  <div v-if="item.url!==''" class="storePicture f-c-c pointer">
                    <div class="icon pointer" @click="removeDocument(item)">×</div>
                    <img style="width:63px;height:63px;" v-if="item.type==='docx'" src="@/assets/img/word.png" alt="" @click="seeDocument(item.url)">
                    <img style="width:63px;height:63px;" v-else-if="item.type==='gif'" src="@/assets/img/GIF.png" alt="" @click="seeDocument(item.url)">
                    <img style="width:63px;height:63px;" v-else-if="item.type==='pdf'" src="@/assets/img/Pdf.png" alt="" @click="seeDocument(item.url)">
                    <el-image v-else fit="contain" style="width: 104px; height: 110px" :src="item.url" :preview-src-list="[item.url]">
                    </el-image>
                  </div>
                  <el-upload v-else list-type="picture-card" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :multiple="false" accept=".png,.jpg,.gif,.docx,.pdf" :before-upload="(file)=>uploadUniversalFile(file,item)">
                    <i class="el-icon-document"></i>
                    <div class="el-upload__text"> <i class="iconfont icon-upload-2-line" style="font-size:18px;"></i> {{ $t('PersonalCenter.MyInformation.Index.Upload') }}</div>
                  </el-upload>
                </div>
              </div>
              <p class="upload-tip">{{ $t('PersonalCenter.MyInformation.Index.UploadFormat') }}：.JPG, .GIF, .DOC OR .PDF ONLY</p>
            </el-col>
          </el-row>
          <h2 style="padding-top:20px;">{{ $t('PersonalCenter.MyInformation.Index.CompanyAddress') }}</h2>
          <el-row>
            <el-col :span="12" style="padding-right: 30px;">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.Address')" prop="address">
                <el-input v-model="form.address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.City')" prop="city">
                <el-input v-model="form.city"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.StateProvince')" prop="stateOrProvince">
                <el-input v-model="form.stateOrProvince"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.ZIPPostalCode')" prop="ipOrPostalCode">
                <el-input v-model="form.ipOrPostalCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.Country')" prop="country">
                <el-select v-model="form.country" :placeholder="$t('common.selectContent')" filterable style="width:100%" @change="handleCountryChange" :filter-method="value=> countryFilterMethod(value)">
                  <el-option v-for="item in addressDataFilter" :key="item.countryCode" :label="item.countryNameEn" :value="item.countryCode">{{item.countryNameEn}}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-right: 30px">
              <el-form-item :label="$t('PersonalCenter.MyInformation.Index.Phone')" prop="phone">
                <el-input v-model="form.phone" :placeholder="$t('common.inputContent')">
                  <el-select v-model="areaCode" filterable slot="prepend" style="color:000;width:100px" @change="handleAreaCodeChange">
                    <el-option v-for="(item,index) in areanolist" :label="item.code" :value="item.code" :key="index">{{item.code}}</el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </section>
      <div class="bottomButton f-a-c">
        <el-button type="primary" style="width: 300px;height: 40px" @click="addCertification" :loading="loading">{{ $t('PersonalCenter.MyInformation.Index.SaveChanges') }}</el-button>
      </div>
    </div>
    <CertificateEquipmentDialog ref="certificateEquipmentDialog"/>
  </div>
</template>

<script>
import API from '@/api'
import areanolist from '@/config/areanolist.js'
import CertificateEquipmentDialog from '../components/CertificateEquipmentDialog.vue'
import { telephoneNumber } from '@/util/validate'
let checktelephoneNumber = (rules, value, callback) => {
  if (telephoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}
export default {
  components: {
    CertificateEquipmentDialog
  },
  data() {
    return {
      form: {},
      areanolist: [],
      areaCode: '+1',
      rules: {
        first: [{ required: true, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips4')}`, trigger: ['change', 'blur'] }],
        ifSellOnline: [{ required: true, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips5')}`, trigger: ['change', 'blur'] }],
        address: [{ required: true, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips6')}`, trigger: ['change', 'blur'] }],
        last: [{ required: true, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips7')}`, trigger: ['change', 'blur'] }],
        companyName: [{ required: true, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips8')}`, trigger: ['change', 'blur'] }],
        // sellerPermit: [{ required: true, message: 'Please enter your seller permit number', trigger: ['change', 'blur'] }],
        city: [{ required: true, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips9')}`, trigger: ['change', 'blur'] }],
        // stateOrProvince: [{ required: true, message: 'Please enter this state or province', trigger: ['change', 'blur'] }],
        // ipOrPostalCode: [{ required: true, message: 'Please enter your postal code', trigger: ['change', 'blur'] }],
        country: [{ required: true, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips10')}`, trigger: ['change', 'blur'] }],
        phone: [{ required: true, validator: checktelephoneNumber, trigger: ['change', 'blur'] }, { max: 20, message: `${this.$t('PersonalCenter.MyInformation.Index.Tips11')}` }]
      },
      addressData: [],
      addressDataFilter: [],
      loading: false,
      imageSignValue: '',
      documentFiles: [
        { url: '', type: '' },
        { url: '', type: '' },
        { url: '', type: '' },
        { url: '', type: '' }
      ]
    }
  },
  created() {
    this.getCertificationInfo()
    this.getAddressInfo()
    this.areanolist = areanolist
    // this.customProductGetSignValue()
  },
  methods: {
    handleAreaCodeChange(value) {
      this.areaCode = value
    },
    beforeUpload(file) {
      API.customProductGetSignValue({ directory: 'common/images/' }).then(res => {
        this.imageSignValue = res.data
        let data = new FormData()
        data.append('directory', 'common/images/')
        data.append('signValue', this.imageSignValue)
        data.append('fileList', file)
        API.orderUploadFile(data).then(res => {
          this.$set(this.form, 'storePicture', res.data)
          this.$forceUpdate()
        })
      })
      return false
    },
    uploadUniversalFile(file, item) {
      API.customProductGetSignValue({ directory: 'common/file/' }).then(res => {
        this.imageSignValue = res.data
        let data = new FormData()
        data.append('directory', 'common/file/')
        data.append('signValue', this.imageSignValue)
        data.append('file', file)
        API.uploadUniversalFile(data).then(res => {
          item.url = res.data
          item.type = file.name.split('.')[file.name.split('.').length - 1]
          console.log(item)
        })
      })
      return false
    },
    removeDocument(item) {
      item.url = ''
      item.type = ''
      this.$forceUpdate()
    },
    removeStorePicture() {
      this.form.storePicture = ''
    },
    getAddressInfo() {
      API.systemAddressInfo().then(res => {
        this.addressData = res.data
        this.addressDataFilter = res.data.slice()
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    countryFilterMethod(searchValue) {
      if (!searchValue) {
        this.addressDataFilter = this.addressData.slice()
      } else {
        const codeArr = []
        const nameArr = []
        this.addressData.forEach(e => {
          if (e.countryCode.includes(searchValue.toUpperCase())) {
            codeArr.push(e)
          } else if (e.countryNameEn.toUpperCase().includes(searchValue.toUpperCase())) {
            nameArr.push(e)
          }
        })
        this.addressDataFilter = [...codeArr, ...nameArr]
      }
    },
    handleCountryChange() {
      const that = this
      setTimeout(() => {
        that.countryFilterMethod('')
      }, 500)
    },
    getCertificationInfo() {
      API.getCertificationInfo(this.$store.state.common.userId).then(res => {
        this.form = res.data ? res.data : {}
        if (res.data.phone.indexOf('-') > -1) {
          this.areaCode = res.data.phone.split('-')[0]
          this.form.phone = res.data.phone.split('-')[1]
        } else {
          this.form.phone = res.data.phone
        }
        res.data.documentOfProofUrl && res.data.documentOfProofUrl.split(',').forEach((item, index) => {
          this.documentFiles[index] = { url: item, type: item.split('.')[item.split('.').length - 1] }
        })
      })
    },
    addCertification() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        let form = { ...this.form }
        form.userId = this.$store.state.common.userId
        form.documentOfProofUrl = this.documentFiles.map(item => item.url).filter(item => item !== '').toString()
        form.phone = `${this.areaCode}-${this.form.phone}`
        this.loading = true
        API.addCertification(form).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success(`${this.$t('PersonalCenter.MyInformation.Index.Tips12')}`)
          this.getCertificationInfo()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    seeDocument(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input-group__prepend {
  color: #606266;
}
/deep/.el-input-group__prepend {
  background-color: #fff;
  width: 80px;
  border-right: none;
}
.page-title {
  display: inline-block;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  padding: 10px 0;
  padding-left: 20px;
}
section {
  margin: 0 0 100px;
  padding: 22px 0 0 28px;
  h2 {
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    color: #000000;
  }
}

.certificate-tips {
  margin: 20px 0;
  height: 113px;
  border: 0.5px solid #E53238;
  padding: 15px 20px;
  .certificate-statu {
    flex: 2;
    width: 145px;
    margin-right: 28px;
    text-align: center;
    span {
      display: inline-block;
      padding-top: 10px;
      width: 145px;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #000000;
    }
  }
  .certificate-info {
    flex: 9;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #000000;
    p span {
      text-decoration: underline;
      color: #000000;
    }
  }
}
.certificated-tips {
  margin: 20px 0;
  width: 183px;
  height: 113px;
  border: 0.5px solid #8b93a3;
  span {
    display: inline-block;
    padding-top: 10px;
    width: 145px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
  }
}
/deep/.el-input--medium .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 2px;
}
/deep/.el-form-item--medium .el-form-item__label {
  line-height: 23px;
  padding-bottom: 5px;
  color: #000000;
}
/deep/.el-upload--picture-card {
  width: 104px;
  height: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 20px;
}
.upload-demo-box{
  margin-right: 15px;

}
.storePicture {
  width: 104px;
  height: 110px;
  border: 1px dashed #c0ccda;
  position: relative;
  img {
    height: 63px;
    width: 63px;
  }
  text-align: center;
  .icon {
    position: absolute;
    width: 23px;
    height: 20px;
    line-height: 16px;
    top: -0px;
    right: 0px;
    text-align: center;
    color: #fff;
    background: rgba(84, 84, 84, 0.6);
    border-radius: 2px 6px 2px 30px;
    z-index: 8;
  }
}
.el-icon-upload2 {
  font-size: 16px;
  // color: #000000;
}
.el-icon-document {
  font-size: 36px;
  color: #cdd4dd;
  margin-bottom: 5px;
}
.el-upload__text {
  // color: #000000;
}
.upload-tip {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #747a87;
  // padding-top: 10px;
  span {
      text-decoration: underline;
      // color: #000000;
    }
}
.bottomButton {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  width: 100%;
  z-index: 9;
  background: #fff;
  box-shadow: 0px -2px 12px 2px rgba(0, 0, 0, 0.06);
}
/deep/.el-col .el-col-16 {
  /deep/.el-form-item__content {
    position: relative;
  }
}
.ifSellOnline {
  position: absolute;
  top: -24px;
  left: 140px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before{
  content: '';
  // color: #F56C6C;
  margin-left: 0px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after, .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:after{
  content: '*';
  color: #F56C6C;
  margin-left: 5px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:after, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after{
  content: '*';
  color: #F56C6C;
}
// .requiredInputPC::after {
//         display: block;
//         content: '*';
//         position: absolute;
//         top: 5px;
//         left: 6px;
//         color: red;
//       }
</style>
